import { Component, Input, OnInit } from '@angular/core';
import { MenuService } from '../mega-menu.service.component';

@Component({
    selector: 'project-menu-mini',
    template: require('./project-mini.component.html')
})
export class ProjectMenuMiniComponent implements OnInit {
    @Input() projectMenu: any; // Update the type based on your projectMenu object type
    sortedTrackers: any;

    constructor(private menuService: MenuService) {}

    init() {
        this.sortedTrackers = this.projectMenu.trackers.sort((a, b) => a.trackerName.localeCompare(b.trackerName));
    }

    ngOnInit(): void {
        this.init();
    }

    ngOnChanges(): void {
        this.init();
    }

    moduleAvailable(moduleName) {
        return this.menuService.moduleAvailable(this.projectMenu, moduleName);
      }

      anyTrackersAvailable() {
        return this.menuService.anyTrackersAvailable(this.projectMenu);
      }

      isProjectMember() {
        return this.menuService.isProjectMember(this.projectMenu);
      }

    trackByFn(index: number, item: any): any {
        return item?.id ?? item;
    }
}
